export { default } from "./theme";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chakra-ui/core/dist/es/theme/index.js
// module id = 174
// module chunks = 0